export const isRuleDeductionApplied = (bet) => {
    return bet.selections.some(selection => selection.rule4Deduction !== undefined);
};
//# sourceMappingURL=isRuleDeductionApplied.js.map